import { RefBool, Ref } from "@tblabs/truffle";
import { Icons } from "./Icons";
import { SvgButton } from "./SvgButton";


export class ChevronButton extends SvgButton
{
    constructor(isFolded: RefBool)
    {
        const icon = new Ref(isFolded ? Icons.ChevronUp : Icons.ChevronDown);

        super(icon, () => isFolded.Toggle());

        isFolded.OnChange(v => icon.value = v ? Icons.ChevronDown : Icons.ChevronUp);
    }
}
